module.exports = __webpack_public_path__ + "img/sc.688ec29b.png";